import { BarChart2, FileText, Columns, Shield } from 'react-feather';
import { TMenuBranch, TMenuLeaf } from '../components/types';
import {
    TABLE_CALL_PERFORMANCE_REPORT_AUTH,
    TABLE_PROSPECTING_MODELS_REPORT_AUTH,
    TABLE_PROSPECTING_SOURCES_REPORT_AUTH,
    TABLE_AI_CALLS_REPORT_AUTH,
    REPORT_WARBOX_MESSAGES_ANALYTICS,
    TABLE_PROSPECTING_AGENT_SOURCES_REPORT_AUTH,
    TABLE_PROSPECTING_AGENCIES_REPORT_AUTH,
    TABLE_AGENTS_COMPARATIVE_REPORT_AUTH,
    TABLE_ADDONS_USAGE_REPORT_AUTH,
    TABLE_AGENTS_CALLS_REPORT_AUTH,
    TABLE_TEMPERATURES_SUBSTATUS_REPORT_AUTH,
    TABLE_EXTRA_SCORES_REPORT_AUTH,
    TABLE_STORES_SCORES_REPORT_AUTH,
    TABLE_FOLLOW_UP_TIME_REPORT_AUTH,
    TABLE_FOLLOW_UP_BY_AGENTS_REPORT_AUTH,
    TABLE_PENDING_TASKS_BY_AGENCIES_REPORT_AUTH,
    TABLE_PROSPECTS_WITH_VISITS_REPORT_AUTH,
    TABLE_INVESTMENTS_BY_CAMPAIGNS_REPORT_AUTH,
    TABLE_PROSPECTING_TOTAL,
    CHART_PROSPECTING_BY_DATE_AND_MODEL_REPORT_AUTH,
    CHART_MASTER_REPORT_AUTH,
    CHART_FUNNEL_STATUS_BY_TEMPERATURE_REPORT_AUTH,
    CHART_PROSPECTING_BY_HOURS_REPORT_AUTH,
    CHART_FUNNEL_BY_PROSPECTING_STATUS_REPORT_AUTH,
    DRILLDOWN_GLOBAL_PROSPECTING_BY_TEMPERATURE_REPORT_AUTH,
    DRILLDOWN_GLOBAL_PROSPECTING_BY_SOURCES_REPORT_AUTH,
    DRILLDOWN_PROSPECTING_BY_AGENTS_REPORT_AUTH,
    DRILLDOWN_SALES_DETAILED_ANALYSIS_REPORT_AUTH,
    DRILLDOWN_LEADS_WITHOUT_ASSIGNMENT_REPORT_AUTH,
    DRILLDOWN_VISITS_DETAILED_ANALYSIS_REPORT_AUTH,
    DRILLDOWN_CALLS_DETAILED_ANALYSIS_REPORT_AUTH,
    DRILLDOWN_APPOINTMENTS_DETAILED_ANALYSIS_REPORT_AUTH,
    TABLE_FOLLOW_UP_RESPONSE_TIME_REPORT_AUTH,
} from 'src/constants/permissions';

export const TABLE_ITEMS: TMenuLeaf[] = [
    {
        title: 'Reports.TABLE_PROSPECTING_TOTAL',
        path: '/reports/prospecting-total',
        permission: TABLE_PROSPECTING_TOTAL,
        tooltip: 'Reports.TABLE_PROSPECTING_TOTAL_DESCRIPTION',
    },
    {
        title: 'Reports.TABLE_CALL_PERFORMANCE_REPORT_AUTH',
        path: '/reports/call-performance',
        permission: TABLE_CALL_PERFORMANCE_REPORT_AUTH,
        tooltip: 'Reports.TABLE_CALL_PERFORMANCE_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.TABLE_PROSPECTING_MODELS_REPORT_AUTH',
        path: '/reports/prospecting-models',
        permission: TABLE_PROSPECTING_MODELS_REPORT_AUTH,
        tooltip: 'Reports.TABLE_PROSPECTING_MODELS_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.TABLE_PROSPECTING_SOURCES_REPORT_AUTH',
        path: '/reports/prospecting-sources',
        permission: TABLE_PROSPECTING_SOURCES_REPORT_AUTH,
        tooltip: 'Reports.TABLE_PROSPECTING_SOURCES_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.TABLE_AI_CALLS_REPORT_AUTH',
        path: '/reports/ai-calls',
        permission: TABLE_AI_CALLS_REPORT_AUTH,
        tooltip: 'Reports.TABLE_AI_CALLS_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.REPORT_WARBOX_MESSAGES_ANALYTICS',
        path: '/reports/warbox-messages',
        permission: REPORT_WARBOX_MESSAGES_ANALYTICS,
        tooltip: 'Reports.REPORT_WARBOX_MESSAGES_ANALYTICS_DESCRIPTION',
    },
    {
        title: 'Reports.TABLE_PROSPECTING_AGENT_SOURCES_REPORT_AUTH',
        path: '/reports/prospecting-agents-sources',
        permission: TABLE_PROSPECTING_AGENT_SOURCES_REPORT_AUTH,
        tooltip:
            'Reports.TABLE_PROSPECTING_AGENT_SOURCES_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.TABLE_PROSPECTING_AGENCIES_REPORT_AUTH',
        path: '/reports/prospecting-agencies',
        permission: TABLE_PROSPECTING_AGENCIES_REPORT_AUTH,
        tooltip: 'Reports.TABLE_PROSPECTING_AGENCIES_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.TABLE_AGENTS_COMPARATIVE_REPORT_AUTH',
        path: '/reports/agents-comparative',
        permission: TABLE_AGENTS_COMPARATIVE_REPORT_AUTH,
        tooltip: 'Reports.TABLE_AGENTS_COMPARATIVE_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.TABLE_AGENTS_CALLS_REPORT_AUTH',
        path: '/reports/agents-calls',
        permission: TABLE_AGENTS_CALLS_REPORT_AUTH,
        tooltip: 'Reports.TABLE_AGENTS_CALLS_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.TABLE_TEMPERATURES_SUBSTATUS_REPORT_AUTH',
        path: '/reports/temperatures-substatus',
        permission: TABLE_TEMPERATURES_SUBSTATUS_REPORT_AUTH,
        tooltip: 'Reports.TABLE_TEMPERATURES_SUBSTATUS_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.TABLE_STORES_SCORES_REPORT_AUTH',
        path: '/reports/stores-score',
        permission: TABLE_STORES_SCORES_REPORT_AUTH,
        tooltip: 'Reports.TABLE_STORES_SCORES_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.TABLE_FOLLOW_UP_TIME_REPORT_AUTH',
        path: '/reports/follow-up-time',
        permission: TABLE_FOLLOW_UP_TIME_REPORT_AUTH,
        tooltip: 'Reports.TABLE_FOLLOW_UP_TIME_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.TABLE_FOLLOW_UP_RESPONSE_TIME_REPORT_AUTH',
        path: '/reports/follow-up-response-time',
        permission: TABLE_FOLLOW_UP_RESPONSE_TIME_REPORT_AUTH,
        tooltip: 'Reports.TABLE_FOLLOW_UP_RESPONSE_TIME_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.TABLE_FOLLOW_UP_BY_AGENTS_REPORT_AUTH',
        path: '/reports/follow-up-by-agents',
        permission: TABLE_FOLLOW_UP_BY_AGENTS_REPORT_AUTH,
        tooltip: 'Reports.TABLE_FOLLOW_UP_BY_AGENTS_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.TABLE_PENDING_TASKS_BY_AGENCIES_REPORT_AUTH',
        path: '/reports/pending-tasks-by-agencies',
        permission: TABLE_PENDING_TASKS_BY_AGENCIES_REPORT_AUTH,
        tooltip:
            'Reports.TABLE_PENDING_TASKS_BY_AGENCIES_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.TABLE_PROSPECTS_WITH_VISITS_REPORT_AUTH',
        path: '/reports/prospects-with-visits',
        permission: TABLE_PROSPECTS_WITH_VISITS_REPORT_AUTH,
        tooltip: 'Reports.TABLE_PROSPECTS_WITH_VISITS_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.TABLE_INVESTMENTS_BY_CAMPAIGNS_REPORT_AUTH',
        path: '/reports/investments-by-campaigns',
        permission: TABLE_INVESTMENTS_BY_CAMPAIGNS_REPORT_AUTH,
        tooltip:
            'Reports.TABLE_INVESTMENTS_BY_CAMPAIGNS_REPORT_AUTH_DESCRIPTION',
    },
];

export const CHARTS_ITEMS: TMenuLeaf[] = [
    {
        title: 'Reports.CHART_PROSPECTING_BY_DATE_AND_MODEL_REPORT_AUTH',
        path: '/charts/prospecting-by-date-and-model',
        permission: CHART_PROSPECTING_BY_DATE_AND_MODEL_REPORT_AUTH,
        tooltip:
            'Reports.CHART_PROSPECTING_BY_DATE_AND_MODEL_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.CHART_MASTER_REPORT_AUTH',
        path: '/charts/master-report',
        permission: CHART_MASTER_REPORT_AUTH,
        tooltip: 'Reports.CHART_MASTER_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.CHART_FUNNEL_STATUS_BY_TEMPERATURE_REPORT_AUTH',
        path: '/charts/funnel-status-by-temperature',
        permission: CHART_FUNNEL_STATUS_BY_TEMPERATURE_REPORT_AUTH,
        tooltip:
            'Reports.CHART_FUNNEL_STATUS_BY_TEMPERATURE_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.CHART_PROSPECTING_BY_HOURS_REPORT_AUTH',
        path: '/charts/prospecting-by-hours',
        permission: CHART_PROSPECTING_BY_HOURS_REPORT_AUTH,
        tooltip: 'Reports.CHART_PROSPECTING_BY_HOURS_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.CHART_FUNNEL_BY_PROSPECTING_STATUS_REPORT_AUTH',
        path: '/charts/funnel-prospecting-by-status',
        permission: CHART_FUNNEL_BY_PROSPECTING_STATUS_REPORT_AUTH,
        tooltip:
            'Reports.CHART_FUNNEL_BY_PROSPECTING_STATUS_REPORT_AUTH_DESCRIPTION',
    },
];

export const DRILLDOWN_ITEMS: TMenuLeaf[] = [
    {
        title: 'Reports.DRILLDOWN_GLOBAL_PROSPECTING_BY_TEMPERATURE_REPORT_AUTH',
        path: '/drilldowns/global-prospecting-by-temperature',
        permission: DRILLDOWN_GLOBAL_PROSPECTING_BY_TEMPERATURE_REPORT_AUTH,
        tooltip:
            'Reports.DRILLDOWN_GLOBAL_PROSPECTING_BY_TEMPERATURE_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.DRILLDOWN_APPOINTMENTS_DETAILED_ANALYSIS_REPORT_AUTH',
        path: '/drilldowns/appointment-detailed-analysis',
        permission: DRILLDOWN_APPOINTMENTS_DETAILED_ANALYSIS_REPORT_AUTH,
        tooltip:
            'Reports.DRILLDOWN_APPOINTMENTS_DETAILED_ANALYSIS_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.DRILLDOWN_GLOBAL_PROSPECTING_BY_SOURCES_REPORT_AUTH',
        path: '/drilldowns/global-prospecting-by-sources',
        permission: DRILLDOWN_GLOBAL_PROSPECTING_BY_SOURCES_REPORT_AUTH,
        tooltip:
            'Reports.DRILLDOWN_GLOBAL_PROSPECTING_BY_SOURCES_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.DRILLDOWN_PROSPECTING_BY_AGENTS_REPORT_AUTH',
        path: '/drilldowns/prospecting-by-agents',
        permission: DRILLDOWN_PROSPECTING_BY_AGENTS_REPORT_AUTH,
        tooltip:
            'Reports.DRILLDOWN_PROSPECTING_BY_AGENTS_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.DRILLDOWN_SALES_DETAILED_ANALYSIS_REPORT_AUTH',
        path: '/drilldowns/sales-detailed-analysis',
        permission: DRILLDOWN_SALES_DETAILED_ANALYSIS_REPORT_AUTH,
        tooltip:
            'Reports.DRILLDOWN_SALES_DETAILED_ANALYSIS_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.DRILLDOWN_LEADS_WITHOUT_ASSIGNMENT_REPORT_AUTH',
        path: '/drilldowns/leads-without-assignment',
        permission: DRILLDOWN_LEADS_WITHOUT_ASSIGNMENT_REPORT_AUTH,
        tooltip:
            'Reports.DRILLDOWN_LEADS_WITHOUT_ASSIGNMENT_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.DRILLDOWN_VISITS_DETAILED_ANALYSIS_REPORT_AUTH',
        path: '/drilldowns/visits-detailed-analysis',
        permission: DRILLDOWN_VISITS_DETAILED_ANALYSIS_REPORT_AUTH,
        tooltip:
            'Reports.DRILLDOWN_VISITS_DETAILED_ANALYSIS_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.DRILLDOWN_CALLS_DETAILED_ANALYSIS_REPORT_AUTH',
        path: '/drilldowns/calls-detailed-analysis',
        permission: DRILLDOWN_CALLS_DETAILED_ANALYSIS_REPORT_AUTH,
        tooltip:
            'Reports.DRILLDOWN_CALLS_DETAILED_ANALYSIS_REPORT_AUTH_DESCRIPTION',
    },
];

export const INTERNAL_ITEMS: TMenuLeaf[] = [
    {
        title: 'Reports.TABLE_ADDONS_USAGE_REPORT_AUTH',
        path: '/internal/addons-usage',
        permission: TABLE_ADDONS_USAGE_REPORT_AUTH,
        tooltip: 'Reports.TABLE_ADDONS_USAGE_REPORT_AUTH_DESCRIPTION',
    },
    {
        title: 'Reports.TABLE_EXTRA_SCORES_REPORT_AUTH',
        path: '/internal/extra-scores',
        permission: TABLE_EXTRA_SCORES_REPORT_AUTH,
        tooltip: 'Reports.TABLE_EXTRA_SCORES_REPORT_AUTH_DESCRIPTION',
    },
];

export const REPORTS_MENU: TMenuBranch[] = [
    {
        title: 'Navbar.Reports',
        Icon: FileText,
        items: TABLE_ITEMS,
    },
    {
        title: 'Navbar.Charts',
        Icon: BarChart2,
        items: CHARTS_ITEMS,
    },
    {
        title: 'Navbar.Drilldown',
        Icon: Columns,
        items: DRILLDOWN_ITEMS,
    },
    {
        title: 'Navbar.Internal',
        Icon: Shield,
        items: INTERNAL_ITEMS,
    },
];
